"use client";

// imports
import { useAtom } from 'jotai';

// lib files
import { passportActivationAtom } from "@/lib/atoms/passport-activation";
import { useHasMounted } from '@/lib/hooks';

// components
import FlowHeader from '@/components/FlowHeader/FlowHeader';

const PassportActivationHeader = () => {
  const [ passportActivateState, _ ] = useAtom(passportActivationAtom);
  const hasMounted = useHasMounted();

  // If the component has not mounted yet, return null to avoid hydration issues
  if (!hasMounted) {
    return null;
  }

  return (
    <FlowHeader
      stationLogo={passportActivateState?.membershipStationLogo || undefined}
      stationShortCommonName={passportActivateState?.membershipStationShortCommonName || undefined}
      showPassportLockup={true}
    />
  );
};

export default PassportActivationHeader;
